import moment from 'moment-timezone'

const phpDateFormatToMomentFormat = (phpFormat) => {
  // по поводу этой темы:
  // https://stackoverflow.com/questions/30186611/php-dateformat-to-moment-js-format
  const replacements = {
    d: 'DD',
    D: 'ddd',
    j: 'D',
    l: 'dddd',
    N: 'E',
    S: 'o',
    w: 'e',
    z: 'DDD',
    W: 'W',
    F: 'MMMM',
    m: 'MM',
    M: 'MMM',
    n: 'M',
    t: '', // no equivalent
    L: '', // no equivalent
    o: 'YYYY',
    Y: 'YYYY',
    y: 'YY',
    a: 'a',
    A: 'A',
    B: '', // no equivalent
    g: 'h',
    G: 'H',
    h: 'hh',
    H: 'HH',
    i: 'mm',
    s: 'ss',
    u: 'SSS',
    e: 'zz', // deprecated since version 1.6.0 of moment.js
    I: '', // no equivalent
    O: '', // no equivalent
    P: '', // no equivalent
    T: '', // no equivalent
    Z: '', // no equivalent
    c: '', // no equivalent
    r: '', // no equivalent
    U: 'X',
  }

  return phpFormat
    .split('')
    .map((s) => replacements[s] || s)
    .join('')
}

export default {
  getDefaultField(option) {
    const { type, name, id } = option
    let value = '-'
    switch (type) {
      case 'checkbox':
        value = false
        break
    }
    return {
      values: [
        {
          value,
        },
      ],
      field_id: id,
      field_name: name,
      field_type: type,
    }
  },
  getFormattedField({
    field,
    dateFormat,
    fieldsConfig,
    currencyDict,
    priceFrom,
    priceFieldId,
    currencySymbol,
    localeService,
  }) {
    if (!field) return
    const copyField = JSON.parse(JSON.stringify(field))
    copyField.field_name = copyField.field_name?.split('#')[0].trim()
    switch (copyField.field_type) {
      case 'date':
        copyField.values[0].value = moment
          .tz(copyField.values[0].value * 1000, dateFormat.timezone)
          .format(phpDateFormatToMomentFormat(dateFormat.dateFormat))
        break
      case 'date_time':
        copyField.values[0].value = moment
          .tz(copyField.values[0].value * 1000, dateFormat.timezone)
          .format(phpDateFormatToMomentFormat(dateFormat.datePattern))
        break
      case 'url':
        copyField.values[0].value = `<a target="_blank" class="text-sky-300 font-light underline" href="${copyField.values[0].value}">Ссылка</a>`
        break
      case 'checkbox': {
        const { value } = copyField.values[0]
        const preparedValue = value ? 'Да' : 'Нет'
        copyField.values[0].value = preparedValue
        break
      }
      case 'numeric': {
        const { value } = copyField.values[0]
        const priceValue = parseInt(value).toLocaleString().split(',').join(' ')
        let preparedValue = value
        const from = priceFrom ? 'от ' : ''

        const fId = copyField.field_id
        const measures = fieldsConfig.measures || []
        const candidateMeasure = measures.find((m) => {
          return m.fieldId === fId
        })
        if (candidateMeasure) {
          const candidateCurrency = currencyDict[candidateMeasure.measure]
          if (candidateMeasure.type === 'valute' && candidateCurrency) {
            const symbol = candidateCurrency.symbol_native || ''
            preparedValue = `${from}${priceValue} ${symbol}`
          }
          if (candidateMeasure.type === 'custom') {
            preparedValue = `${value} ${candidateMeasure.measure}`
          }
        } else if (fId === Number(priceFieldId) || fId === 1) {
          preparedValue = `${from}${priceValue} ${currencySymbol}`
        }

        copyField.values[0].value = preparedValue
        break
      }
      case 'text':
      case 'textarea':
        copyField.values[0].value = copyField.values[0].value?.replaceAll(
          /(?<link>http.+?)(?=\s|$)/gm,
          '<a href="$<link>">Перейти</a>',
        )
        break
      default:
        break
    }

    copyField.valueHtml = copyField.values
      .map((option) => localeService.getTranslatedParam(option.value))
      .join(',<br> ')
    if (copyField.field_id === 1) {
      copyField.field_name = fieldsConfig.budgetName || 'Комиссия'
    }
    return copyField
  },
  isDateField(field) {
    return ['date', 'date_time'].includes(field.field_type)
  },
}
